import React, { useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'

import { useDispatch, useSelector } from 'react-redux'
//import { fetchCategory } from '../actions/productActions'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { BASE_URL } from '../constants/urlConstants'

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from 'react-router-dom'
import { fetchCertificate } from '../actions/certificateActions'

function HomeScreen() {
  const dispatch = useDispatch()
  const listCertificate = useSelector(state => state.listCertificate)
  const { errorOfcertificate, loadingOfcertificate, certificate } = listCertificate

  const listCategory = useSelector(state => state.listCategory)
  const { errorOfcategory, loadingOfcategory, categories } = listCategory

  const listLogoImage = useSelector(state => state.listLogoImage)
  const { errorOflogoImage, loadingOflogoImage, logoImage } = listLogoImage

  const error=false
  const loading=false
if(errorOfcategory){
  error = errorOfcategory
}else if(errorOfcertificate){
  error = errorOfcertificate
}else if(errorOflogoImage){
  error = errorOflogoImage
}
if(loadingOfcategory || loadingOfcertificate || loadingOflogoImage){
  loading = true
}
  

  useEffect(() => {
    //dispatch(fetchCategory())
    dispatch(fetchCertificate())
    //dispatch(fetchLogo())
  }, [])

  return (

    <div className='py-1'>
      <div className="video-container">
        <video
          autoPlay
          muted
          loop
          width="100%"
          height="360"
          controls
        >
          <source src={`${BASE_URL}/public/images/videos/v1.mp4`} type="video/mp4" />
          مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
        </video>
      </div>
      {loading ? <Loader />
        : error ? <Message variant='danger' text={error} />
          : <div>
            <Row className='mt-5'>
              <Col className="flex justify-center p-2"><div className="center pt-3">{logoImage.introduction}</div></Col>
              <Col className='p-2'>
                <div>
                  <img
                    src={`${BASE_URL}/${logoImage.logoHomeImage}`}
                    alt=""
                  />
                </div>
              </Col>
            </Row>
            <Row className='mt-5'>
              {categories.map(category => (
                <Col sm={12} md={6} lg={4} xl={4}>
                  <div >
                    <div id={category._id}>
                      <Link to={`/products/${category._id}`}>
                      <img
                        src={`${BASE_URL}/${category.image}`}
                        alt={category.title}
                        style={{
                          maxWidth: "100%", // تصویر حداکثر به اندازه والدش باشد
                          height: "auto",  // ارتفاع متناسب با عرض تنظیم شود
                        }}
                      />
                      </Link>
                    </div>
                  </div>

                </Col>
              ))}

            </Row>
            <Row>
              <div className="max-w-4xl mx-auto p-4">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  navigation
                  autoplay={{ delay: 2000 }}
                  loop
                  slidesPerView={4}
                  spaceBetween={10}
                  className="!bg-transparent"
                >
                  {certificate.map((certificateItem, index) => (
                    <SwiperSlide key={index} className="flex justify-center">
                      <img src={`${BASE_URL}/${certificateItem.image}`} alt={certificateItem.title} className="w-full h-48 object-cover rounded-xl" />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Row>
            <Row>
             
            </Row>


          </div>
      }
    </div>
  )
}

export default HomeScreen
